import { api } from "./client";

const BASE = "/games/premier_league/table-predictor";

export async function getLockStatus(seasonId) {
  const res = await api.get(`${BASE}/lock-status?season_id=${seasonId}`);
  return res.data;
}

export async function getMyPrediction(poolId, seasonId) {
  const res = await api.get(`${BASE}/mine?season_id=${seasonId}&pool_id=${poolId}`);
  return res.data;
}

export async function saveMyPrediction(poolId, seasonId, positions) {
  const res = await api.put(`${BASE}/mine?season_id=${seasonId}&pool_id=${poolId}`, { positions });
  return res.data;
}

export async function getPoolPredictions(poolId, seasonId) {
  const res = await api.get(`${BASE}/pool?season_id=${seasonId}&pool_id=${poolId}`);
  return res.data;
}
